// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS Reset and Global Styles */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

*::before,
*::after {
  box-sizing: border-box;
}

html {
  height: 100%;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
}

body {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1.5;
  color: #333;
  background-color: #fff;
  overflow-x: hidden;
  position: relative;
}

#root {
  height: 100%;
  width: 100%;
  position: relative;
}

/* Fix cursor positioning issues */
button, 
input[type="button"], 
input[type="submit"], 
input[type="reset"],
.clickable {
  cursor: pointer;
}

a {
  cursor: pointer;
  text-decoration: none;
}

/* Ensure proper pointer events */
* {
  pointer-events: auto;
}

/* Fix layout alignment issues */
.main-layout-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
}

/* Fix header positioning */
.shop-header {
  width: 100%;
  position: relative;
  z-index: 998;
}

/* Fix main content alignment */
main {
  flex: 1 1;
  width: 100%;
  position: relative;
}

/* Remove default list styles */
ul, ol {
  list-style: none;
  padding: 0;
  margin: 0;
}

/* Fix table alignment */
table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}

/* Fix image alignment */
img {
  max-width: 100%;
  height: auto;
  vertical-align: top;
}

/* Fix form element alignment */
input, button, select, textarea {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  margin: 0;
}

input:focus, 
textarea:focus, 
select:focus {
  outline: 2px solid #E84100;
  outline-offset: 2px;
}

/* Fix flexbox alignment issues */
.flex-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Ensure proper scrolling */
html, body {
  scroll-behavior: smooth;
}

/* Fix z-index stacking context */
.modal-overlay,
.login-panel-overlay {
  z-index: 9999;
}

.modal,
.login-panel {
  z-index: 10000;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;;;;;EAKE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;EACE,oBAAoB;AACtB;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,SAAO;EACP,WAAW;EACX,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,SAAS;AACX;;AAEA;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,uBAAuB;AACzB;;AAEA,iCAAiC;AACjC;;EAEE,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE;aACW;AACb","sourcesContent":["/* CSS Reset and Global Styles */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml {\n  height: 100%;\n  -webkit-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  line-height: 1.5;\n  color: #333;\n  background-color: #fff;\n  overflow-x: hidden;\n  position: relative;\n}\n\n#root {\n  height: 100%;\n  width: 100%;\n  position: relative;\n}\n\n/* Fix cursor positioning issues */\nbutton, \ninput[type=\"button\"], \ninput[type=\"submit\"], \ninput[type=\"reset\"],\n.clickable {\n  cursor: pointer;\n}\n\na {\n  cursor: pointer;\n  text-decoration: none;\n}\n\n/* Ensure proper pointer events */\n* {\n  pointer-events: auto;\n}\n\n/* Fix layout alignment issues */\n.main-layout-container {\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n/* Fix header positioning */\n.shop-header {\n  width: 100%;\n  position: relative;\n  z-index: 998;\n}\n\n/* Fix main content alignment */\nmain {\n  flex: 1;\n  width: 100%;\n  position: relative;\n}\n\n/* Remove default list styles */\nul, ol {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n/* Fix table alignment */\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n  width: 100%;\n}\n\n/* Fix image alignment */\nimg {\n  max-width: 100%;\n  height: auto;\n  vertical-align: top;\n}\n\n/* Fix form element alignment */\ninput, button, select, textarea {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  margin: 0;\n}\n\ninput:focus, \ntextarea:focus, \nselect:focus {\n  outline: 2px solid #E84100;\n  outline-offset: 2px;\n}\n\n/* Fix flexbox alignment issues */\n.flex-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Ensure proper scrolling */\nhtml, body {\n  scroll-behavior: smooth;\n}\n\n/* Fix z-index stacking context */\n.modal-overlay,\n.login-panel-overlay {\n  z-index: 9999;\n}\n\n.modal,\n.login-panel {\n  z-index: 10000;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
